"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var colors = _interopRequireWildcard(require("./colors"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @module BaseTheme
 */

const theme = exports.theme = Object.freeze({
  /**
   * Background colors.
   */
  backgrounds: {
    backgroundActionColor: colors.utility.action.base,
    backgroundActionLightColor: colors.labels.blue.background.light,
    backgroundColor: colors.white,
    backgroundDisabledColor: colors.gray[10],
    backgroundErrorColor: colors.utility.error.base,
    backgroundErrorLightColor: colors.labels.red.background.light,
    backgroundPrimaryActiveColor: colors.utility.action.active,
    backgroundPrimaryColor: colors.utility.action.base,
    backgroundPrimaryFocusColor: colors.utility.action.hover,
    backgroundPrimaryHoverColor: colors.utility.action.hover,
    backgroundPrimaryLightColor: colors.labels.blue.background.light,
    backgroundSecondaryActiveColor: colors.gray[10],
    backgroundSecondaryColor: 'transparent',
    backgroundSecondaryFocusColor: 'transparent',
    backgroundSecondaryHoverColor: colors.labels.blue.background.light,
    backgroundTertiaryActiveColor: 'none',
    backgroundTertiaryColor: 'none',
    backgroundTertiaryFocusColor: 'none',
    backgroundTertiaryHoverColor: 'none',
    backgroundValidColor: colors.utility.valid.base,
    backgroundValidLightColor: colors.labels.green.background.light,
    backgroundWarningColor: colors.utility.warning.base,
    backgroundWarningLightColor: colors.labels.yellow.text.light
  },
  /**
   * Border colors.
   */
  borders: {
    borderPrimaryActiveColor: colors.utility.action.base,
    borderPrimaryColor: colors.utility.action.base,
    borderPrimaryFocusColor: colors.utility.action.base,
    borderPrimaryHoverColor: 'transparent',
    borderSecondaryActiveColor: colors.gray[10],
    borderSecondaryColor: 'rgba(0, 158, 204, 0.2)',
    borderSecondaryFocusColor: 'rgba(0, 158, 204, 0.2)',
    borderSecondaryHoverColor: colors.labels.blue.background.light,
    borderTertiaryActiveColor: 'transparent',
    borderTertiaryColor: 'transparent',
    borderTertiaryFocusColor: 'transparent',
    borderTertiaryHoverColor: 'transparent'
  },
  /**
   * All colors.
   */
  colors,
  /**
   * Label colors.
   */
  labels: {
    labelActionActiveColor: colors.white,
    labelActionColor: colors.white,
    labelActionDisabledColor: colors.gray[50],
    labelActionFocusColor: colors.white,
    labelActionHoverColor: colors.white,
    labelErrorActiveColor: colors.white,
    labelErrorColor: colors.white,
    labelErrorDisabledColor: colors.gray[50],
    labelErrorFocusColor: colors.white,
    labelErrorHoverColor: colors.white,
    labelPrimaryActiveColor: colors.white,
    labelPrimaryColor: colors.white,
    labelPrimaryDisabledColor: colors.gray[50],
    labelPrimaryFocusColor: colors.white,
    labelPrimaryHoverColor: colors.white,
    labelSecondaryActiveColor: colors.utility.action.active,
    labelSecondaryColor: colors.labels.blue.text.light,
    labelSecondaryDisabledColor: colors.gray[50],
    labelSecondaryFocusColor: colors.labels.blue.text.light,
    labelSecondaryHoverColor: colors.utility.action.active,
    labelTertiaryActiveColor: colors.utility.action.hover,
    labelTertiaryColor: colors.labels.blue.text.light,
    labelTertiaryDisabledColor: colors.gray[50],
    labelTertiaryFocusColor: colors.labels.blue.text.light,
    labelTertiaryHoverColor: colors.utility.action.active,
    labelValidActiveColor: colors.white,
    labelValidColor: colors.white,
    labelValidDisabledColor: colors.gray[50],
    labelValidFocusColor: colors.white,
    labelValidHoverColor: colors.white,
    labelWarningActiveColor: colors.white,
    labelWarningColor: colors.white,
    labelWarningDisabledColor: colors.gray[50],
    labelWarningFocusColor: colors.white,
    labelWarningHoverColor: colors.white
  },
  /**
   * Shadow colors.
   */
  shadows: {
    boxShadowHover: 'rgba(0, 0, 0, 0.25)'
  },
  /**
   * Utility colors.
   */
  utility: {
    actionColor: colors.utility.action.base,
    black: colors.black,
    errorColor: colors.utility.error.base,
    primaryColor: colors.primary,
    validColor: colors.utility.valid.base,
    warningColor: colors.utility.warning.base,
    white: colors.white
  }
});